import React from "react";
import { Box, Typography } from "@mui/material";

import { AssistantActionButton, AssistantMutedText } from "../../../styles";
import { AssistantScenarioStatus, AssistantScenarioTitle } from "../styles";
import { assistantSummaryCounts } from "./constants";
import {
  AssistantSummary,
  AssistantSummaryIcon,
  AssistantSummaryCounts,
  AssistantSummaryList,
  AssistantSummaryRow,
} from "./styles";
import { IAssistantFeatureSummaryProps } from "./types";

const AssistantFeatureSummary: React.FC<IAssistantFeatureSummaryProps> = ({
  scenarios,
  counts,
  onResume,
}) => (
  <AssistantSummary
    component="section"
    aria-label="Feature walkthrough summary"
  >
    <AssistantSummaryIcon aria-hidden>✓</AssistantSummaryIcon>
    <AssistantMutedText variant="subtitle9">
      Feature walkthrough finished
    </AssistantMutedText>
    <Typography variant="h5" component="h3">
      You’re ready to keep exploring.
    </Typography>
    <AssistantMutedText variant="subtitle7">
      You can finish without completing every scenario. Skipped and unfinished
      lessons stay clearly marked.
    </AssistantMutedText>
    <AssistantSummaryCounts>
      {assistantSummaryCounts.map((item) => (
        <Box key={item.field}>
          <Typography variant="h5">{counts[item.field]}</Typography>
          <AssistantMutedText variant="subtitle9">
            {item.label}
          </AssistantMutedText>
        </Box>
      ))}
    </AssistantSummaryCounts>
    <AssistantSummaryList>
      {scenarios.map((scenario) => (
        <AssistantSummaryRow key={scenario.id}>
          <AssistantScenarioTitle>{scenario.title}</AssistantScenarioTitle>
          <AssistantScenarioStatus status={scenario.status}>
            {scenario.label}
          </AssistantScenarioStatus>
        </AssistantSummaryRow>
      ))}
    </AssistantSummaryList>
    <AssistantActionButton
      variant="outlined"
      round
      fullWidth={false}
      onClick={onResume}
    >
      Return to scenarios
    </AssistantActionButton>
  </AssistantSummary>
);

export default AssistantFeatureSummary;
